// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableWithShowInfoColumn_tableContainer__r\\+NDd {
  overflow-x: auto;
  white-space: nowrap !important;
  scroll-behavior: smooth !important;
  -webkit-overflow-scrolling: touch !important;
  /* overflow-y: hidden !important; */
  transition: all 0.4s ease-out;
  /* height: 100%; */
  /* min-height: 434px; */
  min-height: 380px;
  border: 1px solid #606060;
  border-radius: 7px;
}
.TableWithShowInfoColumn_fullscreentableContainer__5IOQV {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
  overflow-y: auto;
  background-color: #fff;
  padding-inline: 30px;
  /* padding-block-start: 30px; */
  padding-block-end: 100px;
}
.TableWithShowInfoColumn_transitionComponent__fwM0a {
  transition: all 0.4s ease-out;
  padding-top: 50px !important ;
}
.TableWithShowInfoColumn_tableRelativeParent__H-trW {
  padding-top: 30px;
  position: relative;
  margin: auto !important;
  /* border-left: 1px solid rgb(224, 224, 224);
  border-right: 1px solid rgb(224, 224, 224);
  border-top: 1px solid rgb(224, 224, 224);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px; */
}

.TableWithShowInfoColumn_normalScreenTableContainer__Lzc4i {
  /* width: calc(100% + 5px); */
  width: 100%;
  /* margin-top: 27px !important ; */
}
.TableWithShowInfoColumn_scrollableTable__OfkXZ {
  max-height: 100%;
  overflow-y: auto;
}
.TableWithShowInfoColumn_table__Ltsm2 {
  width: 100%;
  border-spacing: 0;
  min-width: 900px;
  /* border: 1px solid #606060;
  border-radius: 7px; */
  table-layout: fixed;
}
.TableWithShowInfoColumn_beforBtnSpan__OSRN6 {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.TableWithShowInfoColumn_afterBtnSpan__8SFmE {
  margin-left: 30px;
  display: flex;
  align-items: center;
}
.TableWithShowInfoColumn_nextBtn__IapfE,
.TableWithShowInfoColumn_prevBtn__iQqJz {
  width: 60px;
  height: 24px;
  border: none;
  background-color: rgb(28, 57, 187);
  color: #fff;
  cursor: pointer;
  border-radius: 3px;
}
.TableWithShowInfoColumn_nextBtn__IapfE {
  padding-left: 5px;
}
.TableWithShowInfoColumn_prevBtn__iQqJz {
  padding-right: 5px;
}
.TableWithShowInfoColumn_paginationItem__h5G-6 {
  width: 24px;
  height: 24px;
  margin: 0 16px;
  border: none;
  background-color: #e4eeee;
  border-radius: 3px;
  cursor: pointer;
}
.TableWithShowInfoColumn_activePaginationItem__FIbs8 {
  background-color: rgb(28, 57, 187);
  border: none;
  color: #fff;
  border-radius: 3px;
}
.TableWithShowInfoColumn_pervNextIconSpan__VQK5Y {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media all and (max-width: 600px) {
  .TableWithShowInfoColumn_beforBtnSpan__OSRN6 {
    margin-right: 10px;
  }
  .TableWithShowInfoColumn_afterBtnSpan__8SFmE {
    margin-left: 10px;
  }
  .TableWithShowInfoColumn_paginationItem__h5G-6 {
    margin: 0 5px;
  }
}
@media all and (max-width: 400px) {
  .TableWithShowInfoColumn_beforBtnSpan__OSRN6 {
    display: none;
  }
  .TableWithShowInfoColumn_afterBtnSpan__8SFmE {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/NewTable/TableWithShowInfoColumn.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,mCAAmC;EACnC,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB;;;;gCAI8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB;uBACqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".tableContainer {\r\n  overflow-x: auto;\r\n  white-space: nowrap !important;\r\n  scroll-behavior: smooth !important;\r\n  -webkit-overflow-scrolling: touch !important;\r\n  /* overflow-y: hidden !important; */\r\n  transition: all 0.4s ease-out;\r\n  /* height: 100%; */\r\n  /* min-height: 434px; */\r\n  min-height: 380px;\r\n  border: 1px solid #606060;\r\n  border-radius: 7px;\r\n}\r\n.fullscreentableContainer {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 10001;\r\n  overflow-y: auto;\r\n  background-color: #fff;\r\n  padding-inline: 30px;\r\n  /* padding-block-start: 30px; */\r\n  padding-block-end: 100px;\r\n}\r\n.transitionComponent {\r\n  transition: all 0.4s ease-out;\r\n  padding-top: 50px !important ;\r\n}\r\n.tableRelativeParent {\r\n  padding-top: 30px;\r\n  position: relative;\r\n  margin: auto !important;\r\n  /* border-left: 1px solid rgb(224, 224, 224);\r\n  border-right: 1px solid rgb(224, 224, 224);\r\n  border-top: 1px solid rgb(224, 224, 224);\r\n  border-top-right-radius: 8px;\r\n  border-top-left-radius: 8px; */\r\n}\r\n\r\n.normalScreenTableContainer {\r\n  /* width: calc(100% + 5px); */\r\n  width: 100%;\r\n  /* margin-top: 27px !important ; */\r\n}\r\n.scrollableTable {\r\n  max-height: 100%;\r\n  overflow-y: auto;\r\n}\r\n.table {\r\n  width: 100%;\r\n  border-spacing: 0;\r\n  min-width: 900px;\r\n  /* border: 1px solid #606060;\r\n  border-radius: 7px; */\r\n  table-layout: fixed;\r\n}\r\n.beforBtnSpan {\r\n  margin-right: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.afterBtnSpan {\r\n  margin-left: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.nextBtn,\r\n.prevBtn {\r\n  width: 60px;\r\n  height: 24px;\r\n  border: none;\r\n  background-color: rgb(28, 57, 187);\r\n  color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n}\r\n.nextBtn {\r\n  padding-left: 5px;\r\n}\r\n.prevBtn {\r\n  padding-right: 5px;\r\n}\r\n.paginationItem {\r\n  width: 24px;\r\n  height: 24px;\r\n  margin: 0 16px;\r\n  border: none;\r\n  background-color: #e4eeee;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n.activePaginationItem {\r\n  background-color: rgb(28, 57, 187);\r\n  border: none;\r\n  color: #fff;\r\n  border-radius: 3px;\r\n}\r\n.pervNextIconSpan {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n@media all and (max-width: 600px) {\r\n  .beforBtnSpan {\r\n    margin-right: 10px;\r\n  }\r\n  .afterBtnSpan {\r\n    margin-left: 10px;\r\n  }\r\n  .paginationItem {\r\n    margin: 0 5px;\r\n  }\r\n}\r\n@media all and (max-width: 400px) {\r\n  .beforBtnSpan {\r\n    display: none;\r\n  }\r\n  .afterBtnSpan {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `TableWithShowInfoColumn_tableContainer__r+NDd`,
	"fullscreentableContainer": `TableWithShowInfoColumn_fullscreentableContainer__5IOQV`,
	"transitionComponent": `TableWithShowInfoColumn_transitionComponent__fwM0a`,
	"tableRelativeParent": `TableWithShowInfoColumn_tableRelativeParent__H-trW`,
	"normalScreenTableContainer": `TableWithShowInfoColumn_normalScreenTableContainer__Lzc4i`,
	"scrollableTable": `TableWithShowInfoColumn_scrollableTable__OfkXZ`,
	"table": `TableWithShowInfoColumn_table__Ltsm2`,
	"beforBtnSpan": `TableWithShowInfoColumn_beforBtnSpan__OSRN6`,
	"afterBtnSpan": `TableWithShowInfoColumn_afterBtnSpan__8SFmE`,
	"nextBtn": `TableWithShowInfoColumn_nextBtn__IapfE`,
	"prevBtn": `TableWithShowInfoColumn_prevBtn__iQqJz`,
	"paginationItem": `TableWithShowInfoColumn_paginationItem__h5G-6`,
	"activePaginationItem": `TableWithShowInfoColumn_activePaginationItem__FIbs8`,
	"pervNextIconSpan": `TableWithShowInfoColumn_pervNextIconSpan__VQK5Y`
};
export default ___CSS_LOADER_EXPORT___;
